// import { UnleashClient, useUnleashContext, useFlag } from '@unleash/proxy-client-vue'
// import { ref, onMounted, onUnmounted } from 'vue'
import { UnleashClient } from 'unleash-proxy-client'
import store from '@/core/store/PersistentStorage'

// const unleashConfig = {
//   url: 'https://featureflags-edge.americanreading.com/api/frontend',
//   clientKey: import.meta.env.VITE_UNLEASH_KEY,
//   refreshInterval: 30,
//   appName: 'arc-reads',
//   // startClient: false
// }

const unleash = new UnleashClient({
  url: import.meta.env.VITE_UNLEASH_URI,
  clientKey: import.meta.env.VITE_UNLEASH_KEY,
  appName: 'arc-reads'
});

// const unleashClient = new UnleashClient(unleashConfig)
// const updateContext = useUnleashContext()

// async function update(info) {
//   if (updateContext) {
//     await updateContext(info)
//   }
// }

if (store.authentication.user?.districtId) {
  // update({ districtId: store.authentication.user.districtId })
  // console.log('unleash.ts if store.authentication.user?.districtId:', store.authentication.user.districtId)
  unleash.setContextField('districtId', store.authentication.user.districtId);
}
else {
  // console.log('ELSE!!!')
  unleash.setContextField('districtId', '');
  // update({ districtId: '' })
}

if (store.authentication.user?.currentInstance?.gradeId) {
  // console.log('unleash.ts if store.authentication.user?.gradeId:', store.authentication.user.currentInstance.gradeId)
  unleash.setContextField('gradeId', store.authentication.user.currentInstance.gradeId);
  // update({ districtId: store.authentication.user.currentInstance.gradeId })
}
else {
  // console.log('ELSE!!!')
  unleash.setContextField('districtId', '');
  // update({ gradeId: '' })
}

// export function isFeatureEnabled(featureToggleName) {
//   return useFlag(featureToggleName).value;
// }

export default unleash;